<template>
  <g stroke="white">
    <rect :fill="getCssColor(color)" :x="7" y="52.5" width="24" height="4"/>*
    <rect :fill="getCssColor(color)" :x="1" y="59" width="36" height="20"/>*
    <path :fill="getCssColor(color)" d="M7,56.5v14h5a7,7,0,0,1,14,0h5v-14Z"/>*
    <rect :fill="getCssColor(color)" :x="7" y="59" width="24" height="2.5"/>*
  </g>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    color: String
  },
  computed: {
    ...mapGetters([
      'getCssColor'
    ])
  }
}
</script>

<style>

</style>
